import {Collapse} from 'antd'
import {useEffect, useState} from 'react'
import {TargetsviewTableCard} from '../targetsview-table-card'
import GridRow from '@components/grid-row'
import {widthLarge} from 'helpers/style'
import {useNavigate} from 'react-router-dom'
import {useDomain} from 'contexts/DomainContext'
import RailAssetUnified from './rail-asset-unified'
const {Panel} = Collapse

const GatewayTargets = ({gatewaysview}) => {
  const [activeKey, setActiveKey] = useState(0) // Controls which panel is open
  const {domain} = useDomain()

  const navigate = useNavigate()
  const handleTargetClick = target => {
    if (target?.id) {
      navigate(`/target/${target.id}`)
    }
  }

  const handleChange = key => {
    // Toggle the panel: if the same key is clicked again, close it
    setActiveKey(activeKey === key ? null : key)
  }

  useEffect(() => {
    // Reset activeKey when gatewaysview changes
    setActiveKey(domain === 'rail' ? 0 : 1)
  }, [gatewaysview, domain])

  if (!gatewaysview) return <></>

  // For other domains (like switchgear), show the original table view
  return (
    <Collapse activeKey={activeKey} onChange={handleChange}>
      <Panel header="Targets" key="1" className="custom-panel">
        <GridRow layout={[24]}>
          <TargetsviewTableCard
            query={{g_id: gatewaysview.g_id}}
            width={widthLarge}
            handleTargetClick={handleTargetClick}
            parentLevel={1}
          />
        </GridRow>
      </Panel>
    </Collapse>
  )
}

export default GatewayTargets
